module.exports = __webpack_public_path__ + "img/about-04-partner-m.a6e37580.png";